import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { TRANSLATIONS, MONTHS } from "@/i18n/translations";

const I18nContext = createContext(null);

const STORAGE_KEY = "editionspro.lang";

function getInitialLang() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "fr" || stored === "en") return stored;
  } catch {}
  const nav = (typeof navigator !== "undefined" ? navigator.language : "fr") || "fr";
  return nav.toLowerCase().startsWith("fr") ? "fr" : "en";
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(getInitialLang());

  const setLang = useCallback((l) => {
    if (l !== "fr" && l !== "en") return;
    setLangState(l);
    try { localStorage.setItem(STORAGE_KEY, l); } catch {}
    if (typeof document !== "undefined") document.documentElement.lang = l;
  }, []);

  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((path, ...args) => {
    const parts = path.split(".");
    let cur = TRANSLATIONS[lang];
    for (const p of parts) {
      if (cur && typeof cur === "object" && p in cur) cur = cur[p];
      else { cur = null; break; }
    }
    if (cur == null) {
      // fallback to French
      let fb = TRANSLATIONS.fr;
      for (const p of parts) {
        if (fb && typeof fb === "object" && p in fb) fb = fb[p];
        else { fb = null; break; }
      }
      cur = fb ?? path;
    }
    if (typeof cur === "function") return cur(...args);
    return cur;
  }, [lang]);

  const months = MONTHS[lang] || MONTHS.fr;

  return (
    <I18nContext.Provider value={{ lang, setLang, t, months }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
